<div *ngIf="taskType" class="task-type-indicator">
  @if (getIconForTaskType(taskType); as svg) {
    <mat-icon [svgIcon]="svg"></mat-icon>
  } @else {
    <mat-icon>{{ taskType === TaskType.FIELD_VISIT ? 'directions_walk' : taskType === TaskType.SUSPECTED_RENTAL ? 'travel_explore' : 'help_outline' }}</mat-icon>
  }
  {{ TaskTypeStrMap.get(taskType) ?? taskType }}
</div>
